import styles from "./styles.module.scss";

export const HSRPApplication = () => {
  return (
    <div className={styles.trainAwsPdApplication}>
      <div className="container">
        <div className={styles.iframeContainer}>
          <iframe
            id="JotFormIFrame-240496539161158"
            title="The Coding School's Summer 2024 High School Research Program"
            onload="window.parent.scrollTo(0,0)"
            allowtransparency="true"
            allowfullscreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/240496539161158"
          >
          </iframe>
        </div>
      </div>
    </div>
  );
};
